import { Link } from "react-router-dom";
import { MONTH_LENGTHS, weeklyOffAllowance } from "./weeklyOffBudget";
import "./AttendanceLeaveSetup.css";

/**
 * Shows how many weekly offs remain after fixed working days.
 * 26 working days → 4 offs in a 30-day month, 5 in a 31-day month, 2 in February.
 */
export default function WeeklyOffBudgetPanel({ workingDays, note, error, showSettingsLink = true }) {
  const fixed = Number(workingDays);
  if (!Number.isFinite(fixed) || fixed <= 0) return null;

  return (
    <div className="als-wo-budget">
      <div className="als-wo-budget-title">Weekly offs use the days left after working days</div>
      <p className="als-wo-budget-sub">
        Working days are fixed at <strong>{fixed}</strong>. Weekly offs allowed = days in the month − {fixed}.
        Saturday and Sunday is about 8 days, and {fixed} + 8 does not fit in a 28, 30, or 31 day month.
        {showSettingsLink ? (
          <>
            {" "}
            <Link to="/salary-v2/setup">Change working days</Link>
          </>
        ) : null}
      </p>
      <div className="als-wo-budget-row">
        {MONTH_LENGTHS.map((row) => (
          <div key={row.days} className="als-wo-budget-cell">
            <span>{row.label}</span>
            <strong>{weeklyOffAllowance(row.days, fixed)} off</strong>
          </div>
        ))}
      </div>
      {error ? <p className="als-wo-budget-error">{error}</p> : null}
      {!error && note ? <p className="als-wo-budget-note">{note}</p> : null}
    </div>
  );
}
